// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid_233Ur","fileInput":"Grid_fileInput_1AS3u","canvas":"Grid_canvas_YVo55","fontLoader":"Grid_fontLoader_2fEqf","nope":"Grid_nope_10K5H","green":"Grid_green_3_oNM"};